export default __webpack_public_path__ + "static/media/jaegertracing.1f679f76.svg";